<div
  class="calendar-container"
  (click)="$event.stopPropagation()"
  (keydown)="$event.stopPropagation()"
>
  <div class="calendar-sidebar">
    <ul>
      <li
        (click)="setQuickFilter('today')"
        (keydown.enter)="setQuickFilter('today')"
        [class.active]="ComparisonNormalizer.string(activeQuickFilter) === 'today'"
      >
        Today
      </li>
      <li
        (click)="setQuickFilter('yesterday')"
        (keydown.enter)="setQuickFilter('yesterday')"
        [class.active]="ComparisonNormalizer.string(activeQuickFilter) === 'yesterday'"
      >
        Yesterday
      </li>
      <li
        (click)="setQuickFilter('last7')"
        (keydown.enter)="setQuickFilter('last7')"
        [class.active]="ComparisonNormalizer.string(activeQuickFilter) === 'last7'"
      >
        Last 7 Days
      </li>
      <li
        (click)="setQuickFilter('last30')"
        (keydown.enter)="setQuickFilter('last30')"
        [class.active]="ComparisonNormalizer.string(activeQuickFilter) === 'last30'"
      >
        Last 30 Days
      </li>
      <li
        (click)="setQuickFilter('thisMonth')"
        (keydown.enter)="setQuickFilter('thisMonth')"
        [class.active]="ComparisonNormalizer.string(activeQuickFilter) === 'thisMonth'"
      >
        This Month
      </li>
      <li
        (click)="setQuickFilter('lastMonth')"
        (keydown.enter)="setQuickFilter('lastMonth')"
        [class.active]="ComparisonNormalizer.string(activeQuickFilter) === 'lastMonth'"
      >
        Last Month
      </li>
      <li
        (click)="activeQuickFilter = 'custom'"
        (keydown.enter)="activeQuickFilter = 'custom'"
        [class.active]="ComparisonNormalizer.string(activeQuickFilter) === 'custom'"
      >
        Custom Range
      </li>
    </ul>
  </div>
  <div class="calendar-main">
    <div class="calendar-header-nav">
      <button
        class="nav-btn"
        type="button"
        (click)="navigateMonth(-1)"
        [disabled]="isYearSelectionMode"
      >
        &lt;
      </button>
      <div class="months-display">
        <div
          class="month-title"
          (click)="toggleYearSelection()"
          (keydown.enter)="toggleYearSelection()"
        >
          {{ months[currentViewDate.getMonth()] }}
          {{ currentViewDate.getFullYear() }}
        </div>
        <div
          class="month-title"
          (click)="toggleYearSelection()"
          (keydown.enter)="toggleYearSelection()"
        >
          {{ months[nextViewDate.getMonth()] }} {{ nextViewDate.getFullYear() }}
        </div>
      </div>
      <button
        class="nav-btn"
        type="button"
        (click)="navigateMonth(1)"
        [disabled]="isYearSelectionMode"
      >
        &gt;
      </button>
    </div>

    <div class="view-content">
      <!-- Month Picker Grid -->
      @if (!isYearSelectionMode) {
        <div class="calendar-grids-container">
          <!-- First Month -->
          <div class="month-grid-wrapper">
            <div class="days-header">
              <span>Su</span><span>Mo</span><span>Tu</span><span>We</span
              ><span>Th</span><span>Fr</span><span>Sa</span>
            </div>
            <div class="calendar-grid">
              @for (day of firstMonthDays; track day) {
                <span
                  [class.muted]="!day.isCurrentMonth"
                  [class.selected]="day.isSelected"
                  [class.in-range]="day.isInRange"
                  [class.today]="day.isToday"
                  [class.disabled]="day.isDisabled"
                  (click)="selectDate(day.date)"
                  (keydown.enter)="selectDate(day.date)"
                >
                  {{ day.date.getDate() }}
                </span>
              }
            </div>
          </div>
          <!-- Second Month -->
          <div class="month-grid-wrapper">
            <div class="days-header">
              <span>Su</span><span>Mo</span><span>Tu</span><span>We</span
              ><span>Th</span><span>Fr</span><span>Sa</span>
            </div>
            <div class="calendar-grid">
              @for (day of secondMonthDays; track day) {
                <span
                  [class.muted]="!day.isCurrentMonth"
                  [class.selected]="day.isSelected"
                  [class.in-range]="day.isInRange"
                  [class.today]="day.isToday"
                  [class.disabled]="day.isDisabled"
                  (click)="selectDate(day.date)"
                  (keydown.enter)="selectDate(day.date)"
                >
                  {{ day.date.getDate() }}
                </span>
              }
            </div>
          </div>
        </div>
      }

      <!-- Year Picker Grid -->
      @if (isYearSelectionMode) {
        <div class="year-selector-grid">
          @for (year of years; track year) {
            <div
              class="year-item"
              [class.active]="year === currentViewDate.getFullYear()"
              (click)="selectYear(year)"
              (keydown.enter)="selectYear(year)"
            >
              {{ year }}
            </div>
          }
        </div>
      }
    </div>

    <div class="calendar-footer">
      <div class="left-section horizontal-line">
        <div class="selected-range-display">
          {{ getFormattedRange() }}
        </div>
        <div
          class="reset-section"
          [class.disabled]="getFormattedRange() === 'Select range'"
          [attr.disabled]="getFormattedRange() === 'Select range' ? true : null"
          (click)="onReset()"
          (keydown.enter)="onReset()"
        >
          Reset
        </div>
      </div>
      <div class="footer-actions">
        <button class="btn-cancel" (click)="onCancel()">Cancel</button>
        <button
          class="btn-apply"
          [disabled]="isApplyDisabled"
          (click)="onApply()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
